import { JetView } from 'webix-jet'; // Importing JetView from webix-jet framework
import SportBets from 'views/cash/bets/sport'; // Importing SportBets view
import { urlCasinoPlay, profile, src, devConfig } from 'config/config'; // Importing configuration variables

/**
 * Class representing the reprintCheckView.
 * @extends JetView
 */
export default class reprintCheckView extends JetView {
    /**
     * Configures the view layout and components.
     * @returns {Object} The configuration object for the view.
     */
    config() {
        const _ = this.app.getService('locale')._; // Localization service
        const theme = this.app.config.theme; // Theme configuration
        const templateConfig = {
            id: 'iframe', // ID for the iframe template
            view: 'template', // Webix template view
            template: "<iframe style='overflow: scroll; height: 100%; width: 100%;'></iframe>", // Iframe template
        };
        const popup21 = webix.ui({
            // Popup for unregistered user
            id: 'filterPopup21',
            view: 'window',
            position: 'center',
            modal: true,
            css: {
                'border-width': '0px !important', // CSS for popup border
                'border-radius': '10px !important', // CSS for popup border radius
            },
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label:
                            `<span style='color: #FFFFFF !important; padding-left: 10px !important;'>` +
                            _('USUARIO NO REGISTRADO') + // Label for unregistered user
                            `</span>`,
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup on click
                        },
                    },
                ],
                css: {
                    'background-color': '#404563', // Toolbar background color
                    color: 'white !important', // Toolbar text color
                },
            },
            body: {
                width: 570, // Body width
                height: 200, // Body height
                padding: 10, // Body padding
                rows: [
                    {
                        view: 'label',
                        label: "<span style='font-size: 20px; font-weight: normal'>No tienes una cuenta asociada.</span>", // Message for no account
                        css: {
                            'text-align': 'center', // Center text alignment
                        },
                    },
                    {
                        view: 'label',
                        label: '<span>Para acceder a nuestras apuestas, <strong>por favor regístrate.</strong></span>', // Registration prompt
                        css: {
                            'text-align': 'center', // Center text alignment
                        },
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: 'Salir', // Exit button
                                autowidth: true,
                                click: function () {
                                    this.getTopParentView().hide(); // Hide the popup on click
                                },
                            },
                            {
                                view: 'button',
                                type: 'form',
                                value: 'Regístrate aquí', // Registration button
                                css: 'webix_primary',
                                hidden: profile.linkAffiliate === null || profile.linkAffiliate === '', // Hide if no affiliate link
                                autowidth: true,
                                click: function () {
                                    this.getTopParentView().hide(); // Hide the popup on click
                                    window.open(
                                        profile.linkAffiliate, // Open affiliate link in new tab
                                        '_blank',
                                    );
                                },
                            },
                        ],
                        css: {
                            display: 'flex', // Flexbox for layout
                            'justify-content': 'center', // Center items
                            'align-items': 'center', // Align items
                            gap: '10px', // Gap between items
                            'margin-top': '15px !important', // Top margin
                        },
                    },
                ],
                css: {
                    display: 'flex', // Flexbox for layout
                    'flex-direction': 'column', // Column direction
                    'justify-content': 'center', // Center items
                    'align-items': 'center', // Align items
                    gap: '0px !important', // No gap
                },
            },
        });
        const popup11 = webix.ui({
            // Popup for identification
            view: 'window',
            id: 'filterPopup11',
            css: {
                'border-width': '0px !important', // CSS for popup border
                'border-radius': '10px !important', // CSS for popup border radius
            },
            head: {
                view: 'toolbar',
                cols: [
                    {
                        view: 'label',
                        label:
                            `<span style='color: #FFFFFF !important; padding-left: 10px !important;'>` +
                            _('IDENTIFICACIÓN') + // Label for identification
                            `</span>`,
                        textAlign: 'center',
                        css: {
                            color: '#fff !important', // Text color
                            'font-size': '20px', // Font size
                            'font-weight': 'bold', // Font weight
                            'text-transform': 'uppercase', // Uppercase text
                        },
                    },
                    {
                        view: 'icon',
                        icon: 'wxi-close', // Close icon
                        click: function () {
                            this.getTopParentView().hide(); // Hide the popup on click
                            $$('myForm222').clear(); // Clear the form
                        },
                    },
                ],
                css: {
                    'background-color': '#404563', // Toolbar background color
                    color: 'white !important', // Toolbar text color
                },
            },
            modal: true,
            position: 'center',
            body: {
                view: 'form',
                id: 'myForm222', // Form ID
                type: 'clean', // Clean form type
                width: 570, // Form width
                height: 170, // Form height
                paddingX: 20, // Horizontal padding
                paddingY: 10, // Vertical padding
                rows: [
                    {
                        view: 'text',
                        name: 'docnumber', // Document number field
                        id: 'docnumber',
                        type: 'number', // Field type
                        // Define the label text dynamically based on which anonymous betting options are active
                        label:
                        // If both document and phone options are active
                            (profile.IsActiveAnonymousDocument && profile.IsActiveAnonymousPhone)
                                ? '<span>Para comenzar a apostar, por favor, <strong>introduce tu número de documento o celular.</strong></span>'
                                // If only phone is active
                                : (!profile.IsActiveAnonymousDocument && profile.IsActiveAnonymousPhone)
                                    ?  '<span>Para comenzar a apostar, por favor, <strong>introduce tu número de celular.</strong></span>'
                                    // Otherwise, only document is active
                                    : '<span>Para comenzar a apostar, por favor, <strong>introduce tu número de documento.</strong></span>',
                        labelPosition: 'top', // Label position
                        required: true, // Required field
                        invalidMessage: _(
                            'Por favor, introduce tu documento de identificación', // Invalid message
                        ),
                        css: 'webix_inputNumber', // CSS class for input
                    },
                    {
                        cols: [
                            {
                                view: 'button',
                                value: _('Continuar'), // Continue button
                                type: 'form',
                                width: 150,
                                css: 'webix_primary',
                                click: function () {
                                    const form = $$('myForm222'); // Get form instance
                                    if (form.validate()) {
                                        // Validate form
                                        const values = form.getValues(); // Get form values
                                        webix
                                            .ajax() // AJAX request
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Account/ExitsDocument', // API endpoint
                                                values, // Data to send
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        localStorage.removeItem(
                                                            'relationshipUserOnline', // Clear local storage on error
                                                        );
                                                        devConfig.setRelationshipUserOnline('');
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        var json = JSON.parse(text); // Parse response
                                                        if (json.HasError) {
                                                            // Check for errors
                                                            localStorage.removeItem(
                                                                'relationshipUserOnline', // Clear local storage on error
                                                            );
                                                            devConfig.setRelationshipUserOnline('');
                                                            popup21.show(); // Show unregistered user popup
                                                        } else {
                                                            webix
                                                                .ui({
                                                                    // Show registered user popup
                                                                    id: 'filterPopup31',
                                                                    view: 'window',
                                                                    position: 'center',
                                                                    modal: true,
                                                                    css: {
                                                                        'border-width': '0px !important', // CSS for popup border
                                                                        'border-radius': '10px !important', // CSS for popup border radius
                                                                    },
                                                                    head: {
                                                                        view: 'toolbar',
                                                                        cols: [
                                                                            {
                                                                                view: 'label',
                                                                                label:
                                                                                    `<span style='color: #FFFFFF !important; padding-left: 10px !important;'>` +
                                                                                    _(
                                                                                        'USUARIO REGISTRADO', // Label for registered user
                                                                                    ) +
                                                                                    `</span>`,
                                                                            },
                                                                            {
                                                                                view: 'icon',
                                                                                icon: 'wxi-close', // Close icon
                                                                                click: function () {
                                                                                    this.getTopParentView().hide(); // Hide the popup on click
                                                                                },
                                                                            },
                                                                        ],
                                                                        css: {
                                                                            'background-color': '#404563', // Toolbar background color
                                                                            color: 'white !important', // Toolbar text color
                                                                        },
                                                                    },
                                                                    body: {
                                                                        width: 500, // Body width
                                                                        height: 250, // Body height
                                                                        padding: 10, // Body padding
                                                                        rows: [
                                                                            {
                                                                                view: 'label',
                                                                                label: "<span style='font-size: 18px; font-weight: normal'>¿Son estos tus datos?</span>", // Confirmation message
                                                                                css: {
                                                                                    'text-align': 'center', // Center text alignment
                                                                                },
                                                                            },
                                                                            {
                                                                                view: 'label',
                                                                                label:
                                                                                    `<span style='font-size: 20px; font-weight: bold'>` +
                                                                                    _('ID:') +
                                                                                    ' ' +
                                                                                    json.data.id +
                                                                                    `</span>`, // Display user ID
                                                                                css: {
                                                                                    'text-align': 'center', // Center text alignment
                                                                                },
                                                                            },
                                                                            {
                                                                                view: 'label',
                                                                                // Dynamically sets the label based on which anonymous betting options are enabled
                                                                                label:
                                                                                // If both Document and Phone options are enabled
                                                                                    (profile.IsActiveAnonymousDocument && profile.IsActiveAnonymousPhone)
                                                                                        ? `<span style='font-size: 20px; font-weight: bold'>` +
                                                                                        _('DOCUMENTO O CELULAR:') + json.data.value +
                                                                                        `</span>`
                                                                                        // If only Phone is enabled
                                                                                        : (!profile.IsActiveAnonymousDocument && profile.IsActiveAnonymousPhone)
                                                                                            ? `<span style='font-size: 20px; font-weight: bold'>` +
                                                                                            _('CELULAR:') + json.data.value +
                                                                                            `</span>`
                                                                                            // Otherwise, only Document is enabled
                                                                                            : `<span style='font-size: 20px; font-weight: bold'>` +
                                                                                            _('DOCUMENTO:') + json.data.value +
                                                                                            `</span>`,
                                                                                css: {
                                                                                    'text-align': 'center', // Center text alignment
                                                                                },
                                                                            },
                                                                            {
                                                                                view: 'label',
                                                                                label:
                                                                                    `<span style='font-size: 20px; font-weight: bold; text-transform: uppercase'>` +
                                                                                    json.data.name +
                                                                                    `</span>`, // Display user name
                                                                                css: {
                                                                                    'text-align': 'center', // Center text alignment
                                                                                },
                                                                            },
                                                                            {
                                                                                cols: [
                                                                                    {
                                                                                        view: 'button',
                                                                                        value: 'Cancelar', // Cancel button
                                                                                        autowidth: true,
                                                                                        click: function () {
                                                                                            this.getTopParentView().hide(); // Hide the popup on click
                                                                                        },
                                                                                    },
                                                                                    {
                                                                                        view: 'button',
                                                                                        type: 'form',
                                                                                        value: 'Si, comenzar a apostar', // Start betting button
                                                                                        css: 'webix_primary',
                                                                                        autowidth: true,
                                                                                        click: function () {
                                                                                            webix
                                                                                                .ajax() // AJAX request
                                                                                                .headers({
                                                                                                    'Content-type':
                                                                                                        'application/json', // Set content type
                                                                                                })
                                                                                                .post(
                                                                                                    devConfig.geturlApi() +
                                                                                                        'Account/OnlineUserRelationship', // API endpoint
                                                                                                    {
                                                                                                        docnumber:
                                                                                                            json.data
                                                                                                                .id, // Send user ID
                                                                                                    },
                                                                                                    {
                                                                                                        error: function (
                                                                                                            text,
                                                                                                            data,
                                                                                                            XmlHttpRequest,
                                                                                                        ) {
                                                                                                            devConfig.setOnRelationshipUserOnline(
                                                                                                                '', // Clear online user relationship on error
                                                                                                            );
                                                                                                            window.location.reload(); // Reload the page
                                                                                                        },
                                                                                                        success:
                                                                                                            function (
                                                                                                                text,
                                                                                                                data,
                                                                                                                XmlHttpRequest,
                                                                                                            ) {
                                                                                                                window.location.reload(); // Reload the page
                                                                                                                localStorage.setItem(
                                                                                                                    'relationshipUserOnline',
                                                                                                                    JSON.stringify(
                                                                                                                        json.data, // Store user data in local storage
                                                                                                                    ),
                                                                                                                );
                                                                                                            },
                                                                                                    },
                                                                                                );
                                                                                        },
                                                                                    },
                                                                                ],
                                                                                css: {
                                                                                    display: 'flex', // Flexbox for layout
                                                                                    'justify-content': 'center', // Center items
                                                                                    'align-items': 'center', // Align items
                                                                                    gap: '10px', // Gap between items
                                                                                    'margin-top': '15px !important', // Top margin
                                                                                },
                                                                            },
                                                                        ],
                                                                        css: {
                                                                            display: 'flex', // Flexbox for layout
                                                                            'flex-direction': 'column', // Column direction
                                                                            'justify-content': 'center', // Center items
                                                                            'align-items': 'center', // Align items
                                                                            gap: '0px !important', // No gap
                                                                        },
                                                                    },
                                                                })
                                                                .show(); // Show the registered user popup
                                                        }
                                                    },
                                                },
                                            );
                                        this.getTopParentView().hide(); // Hide the popup
                                        $$('myForm222').clear(); // Clear the form
                                    }
                                },
                            },
                        ],
                        css: {
                            display: 'flex', // Flexbox for layout
                            'justify-content': 'center', // Center items
                            'align-items': 'center', // Align items
                            'margin-top': '20px !important', // Top margin
                        },
                    },
                ],
                css: {
                    display: 'flex', // Flexbox for layout
                    'flex-direction': 'column', // Column direction
                    'justify-content': 'center', // Center items
                    'align-items': 'center', // Align items
                    gap: '10px', // Gap between items
                },
                rules: {
                    docnumber: webix.rules.isNotEmpty, // Validation rule for document number
                },
            },
        });
        const left = {
            id: 'BIA_client_2', // ID for the left panel
            responsiveCell: false,
            hidden: true, // Initially hidden
            rows: [
                {
                    view: 'toolbar',
                    css: theme, // Toolbar theme
                    elements: [
                        { view: 'label', label: _('GoldenRace'), width: 300 }, // Label for GoldenRace
                        {},
                        {
                            hidden: !devConfig.getOnRelationshipUserOnline(), // Show if user is online
                            cols: [
                                {
                                    view: 'icon',
                                    icon: 'wxi-user', // User icon
                                    css: 'webix_primaryIconCustom',
                                },
                                {
                                    id: 'BIA_client_ID', // ID for client ID display
                                    view: 'text',
                                    width: 140,
                                    disabled: true, // Disabled input
                                    css: 'webix_primaryCustom',
                                    value: 'Cargando...', // Loading message
                                },
                                {
                                    view: 'icon',
                                    icon: 'wxi-close', // Close icon
                                    css: 'webix_primaryExitCustom',
                                    click: function () {
                                        webix
                                            .ajax() // AJAX request for logout
                                            .headers({
                                                'Content-type': 'application/json', // Set content type
                                            })
                                            .post(
                                                devConfig.geturlApi() + 'Account/LogoutRelationshipUser', // API endpoint
                                                {
                                                    error: function (text, data, XmlHttpRequest) {
                                                        devConfig.setOnRelationshipUserOnline(
                                                            '', // Clear online user relationship on error
                                                        );
                                                        $$('BIA_client').show(); // Show client panel
                                                        $$('BIA_client_2').hide(); // Hide secondary panel
                                                        $$('BIA_client_ID').setValue(''); // Clear client ID
                                                        $$('BIA_client_ID').refresh(); // Refresh client ID display
                                                    },
                                                    success: function (text, data, XmlHttpRequest) {
                                                        devConfig.setOnRelationshipUserOnline(
                                                            '', // Clear online user relationship on success
                                                        );
                                                        $$('BIA_client').show(); // Show client panel
                                                        $$('BIA_client_2').hide(); // Hide secondary panel
                                                        $$('BIA_client_ID').setValue(''); // Clear client ID
                                                        $$('BIA_client_ID').refresh(); // Refresh client ID display
                                                    },
                                                },
                                            );
                                    },
                                },
                            ],
                        },
                    ],
                },
                {
                    id: 'BIA_client_IFRAME', // ID for the iframe container
                    cols: [],
                },
            ],
        };
        webix.ui.fullScreen(); // Set full screen mode
        webix.Touch.limit(); // Limit touch events
        return {
            id: 'BIA_client_Main', // Main view ID
            type: 'wide', // View type
            responsive: true, // Responsive layout
            css: 'out', // CSS class
            cols: [
                {
                    id: 'BIA_client', // ID for the client panel
                    responsiveCell: false,
                    rows: [
                        {
                            view: 'toolbar',
                            css: theme, // Toolbar theme
                            elements: [
                                {
                                    view: 'label',
                                    label: _('GoldenRace'), // Label for GoldenRace
                                    width: 300,
                                },
                            ],
                        },
                        {
                            view: 'template',
                            css: 'webix_template33', // CSS class for template
                            template: `<div style='display: flex; justify-content: center; align-items: center; height: 100%; background-color: #A9A9A9'><button class='my-custom-button'>Iniciar sesión</button></div>`, // Template with login button
                            onClick: {
                                'my-custom-button': function () {
                                    $$('filterPopup11').show(); // Show identification popup on button click
                                },
                            },
                        },
                    ],
                },
                !devConfig.getOnRelationshipUserOnline() // Conditional rendering based on user online status
                    ? left
                    : devConfig.getOnRelationshipUserOnline() !== ''
                      ? left
                      : { hidden: true },
            ],
        };
    }

    /**
     * Initializes the view and sets up event listeners.
     */
    init() {
        const relationshipUserVirtuals = devConfig.getRelationshipUserOnline(); // Get online user relationship
        if (!devConfig.getOnRelationshipUserOnline()) {
            // If user is not online
            $$('BIA_client').hide(); // Hide client panel
            $$('BIA_client_2').show(); // Show secondary panel

            webix.message({
                type: "error",
                text: "Funcionalidad de apuestas anónimas no disponible para este contexto. Contacta al administrador.",
            });
            devConfig.setSrc(
                urlCasinoPlay +
                    '&lan=' +
                    profile.LangId +
                    '&partnerid=' +
                    profile.PartnerSelected +
                    '&token=' +
                    localStorage.getItem('casino_token') +
                    '&currency=' +
                    profile.CurrencyId +
                    '&userid=' +
                    profile.AgentId +
                    '&isMobile=' +
                    /iPhone|iPad|iPod|Android/i.test(navigator.userAgent), // Check if mobile
            );
            console.log(devConfig.getSrc()); // Log the source URL
            $$('BIA_client_IFRAME').addView({
                id: 'iframe', // ID for iframe
                view: 'template',
                template:
                    "<iframe id='goldenRace' style='overflow: scroll; height: 100%; width: 100%;' src='" +
                    devConfig.getSrc() +
                    "'></iframe>", // Iframe with source URL
            });
        } else if (relationshipUserVirtuals !== undefined && relationshipUserVirtuals !== '') {
            // If user is online and has a relationship
            webix
                .ajax() // AJAX request
                .headers({
                    'Content-type': 'application/json', // Set content type
                })
                .post(
                    devConfig.geturlApi() + 'Account/OnlineUserRelationship', // API endpoint
                    {
                        docnumber: relationshipUserVirtuals, // Send document number
                    },
                    {
                        error: function (text, data, XmlHttpRequest) {
                            devConfig.setOnRelationshipUserOnline(''); // Clear online user relationship on error
                        },
                        success: function (text, data, XmlHttpRequest) {
                            let json = JSON.parse(text); // Parse response
                            $$('BIA_client_ID').setValue(json.data[0]); // Set client ID display
                            $$('BIA_client_ID').refresh(); // Refresh client ID display
                            devConfig.setSrc(
                                urlCasinoPlay +
                                    '&lan=' +
                                    profile.LangId +
                                    '&partnerid=' +
                                    profile.PartnerSelected +
                                    '&token=' +
                                    localStorage.getItem('casino_token') +
                                    '&currency=' +
                                    profile.CurrencyId +
                                    '&userid=' +
                                    profile.AgentId +
                                    '&isMobile=' +
                                    /iPhone|iPad|iPod|Android/i.test(
                                        navigator.userAgent, // Check if mobile
                                    ),
                            );
                            console.log(devConfig.getSrc()); // Log the source URL
                            $$('BIA_client_IFRAME').addView({
                                id: 'iframe', // ID for iframe
                                view: 'template',
                                template:
                                    "<iframe style='overflow: scroll; height: 100%; width: 100%;' src='" +
                                    devConfig.getSrc() +
                                    "'></iframe>", // Iframe with source URL
                            });
                        },
                    },
                );
            $$('BIA_client').hide(); // Hide client panel
            $$('BIA_client_2').show(); // Show secondary panel
            this.on(this.app, 'logoutUserGoldenRace', (filterData) => {
                // Event listener for logout
                devConfig.setOnRelationshipUserOnline(''); // Clear online user relationship
                $$('BIA_client').show(); // Show client panel
                $$('BIA_client_2').hide(); // Hide secondary panel
                $$('BIA_client_ID').setValue(''); // Clear client ID
                $$('BIA_client_ID').refresh(); // Refresh client ID display
            });
        }
    }
}

// FILE DOCUMENTED
